import styled from 'styled-components';

export const GradientFilter = styled('div')`
  position: fixed;
  top: 0;
  height: 100%;
  width: 100%;
  background: linear-gradient(
    180deg,
    rgba(21, 27, 36, 0) 0%,
    rgba(21, 27, 36, 0.9) 69.75%,
    #151b24 100%
  );
  z-index: 1;
`;

export const ContentWrapper = styled('div')`
  z-index: 1;
  text-align: center;
  position: sticky;
  bottom: 100px;
  color: white;
  > button {
    margin: ${({ theme }) => theme.x3spacePx}px 0;
  }
  > p {
    ${({ theme }) => theme.typography.tiny}
    > span {
      color: ${({ theme }) => theme.color.warning};
    }
  }
`;
